import { Alert, Box, Button, Grid, Modal, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import postOnSlack from 'src/core/postOnSlack';
import {
  getTodayDateTimeUTC,
  sendFormSubmissionEmail,
  updateEnterpriseLeadsInGoogleSheet,
  validateEmail,
} from 'src/utils/functions';
import CloseIcon from '@material-ui/icons/Close';
import { COLOR_PRIMARY_1, SIDEBAR_COLOR } from 'src/colors';

const RealtorForm = ({
  user,
  showRealtorForm,
  setshowRealtorForm,
  successAlert,
  handleOnSampleClick,
  matches,
  searchBarValue,
  customCenterLng,
  customCenterLat,
}) => {
  const [email, setEmail] = useState<string>(user.email == 'Trial' ? '' : user.email);
  const [name, setName] = useState<string>(user.userName == 'Trial' ? '' : user.userName);
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [budget, setBudget] = useState<string>('');
  const [additionNote, setAdditionalNote] = useState<string>('');
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);
  const [updateInGoogleSheetCounter, setUpdateInGoogleSheetCounter] = useState<number>(0);
  const [showEmailNotEnteredWarning, setEmailNotEnteredWarning] = useState<boolean>(false);
  const [showEnterValidEmailWarning, setEnterValidEmailWarning] = useState<boolean>(false);
  
  useEffect(() => {
    setEmail(user.email == 'Trial' ? '' : user.email);
    setName(user.userName == 'Trial' ? '' : user.userName);
  }, [user]);

  useEffect(() => {
    if (updateInGoogleSheetCounter > 0 && validateEmail(email)) {
      updateInGoogleSheet();
    }
  }, [updateInGoogleSheetCounter]);

  const closeUserDetailsFormModal = () => {
    setshowRealtorForm(false);
    setIsFormSubmitted(false);
    handleOnSubmitBtn();
    setUpdateInGoogleSheetCounter(updateInGoogleSheetCounter + 1);
  };

  const updateInGoogleSheet = () => {
    let todaysDate = getTodayDateTimeUTC();
    const formattedAddress = searchBarValue.address;
    if (isFormSubmitted) {
      updateEnterpriseLeadsInGoogleSheet('finished_realtor', `[${todaysDate}|${name}|${email}|${phoneNumber}|${budget}|${additionNote}|${user['signupCountryCode']}|${formattedAddress}]`);
    } else {
      updateEnterpriseLeadsInGoogleSheet('not_finished_realtor', `[${todaysDate}|${name}|${email}|${phoneNumber}|${budget}|${additionNote}|${user['signupCountryCode']}|${formattedAddress}]`);
    }
  };

  const sendMailAfterFormSubmission = () => {
    if (email !== 'Trial' && email !== '') {
      if (validateEmail(email)) {
        let name = user.userName == 'Trial' ? '' : user.userName;
        let emailText = `<b>Hi ${name},</b> <br><br> This is to confirm that we have received your inquiry for Airbtics realtor services. Our team will review it promptly, <br> and you can expect a response within 2-3 working days. <br><br> Thanks, <br> Support<br>(Airbtics)`;
        let title = 'Confirmation: Your Inquiry for Airbtics Realtor Services ';
        sendFormSubmissionEmail(email, emailText, title);
        email !== 'Trial' && email !== '' && successAlert('Form submitted successfully');
      }
    }
  };

  const handleOnSubmitBtn = async () => {
    if (email === 'Trial' || email === '') {
      setEmailNotEnteredWarning(true);
      setEnterValidEmailWarning(false);
    } else {
      if (validateEmail(email)) {
        setEmailNotEnteredWarning(false);
        setEnterValidEmailWarning(false);
        setshowRealtorForm(false);
        let message = `Leads: Interested in connecting to realtor.\nName: ${name}\nUser: ${email}\nPhone Number: ${phoneNumber}\nBudget: ${budget}\nAdditional notes: ${additionNote}\nUser Signup Country: ${user['signupCountryCode']}\nUser Searched Address: ${searchBarValue.address}\nCoordinates: (${customCenterLat}, ${customCenterLng})`;
        let sendSlackMessage = await postOnSlack('C072095QUU9', message);
        setUpdateInGoogleSheetCounter(updateInGoogleSheetCounter + 1);
      } else {
        setEmailNotEnteredWarning(false);
        setEnterValidEmailWarning(true);
      }
    }
  };

  return (
    <Modal
      open={showRealtorForm}
      onClose={closeUserDetailsFormModal}
      style={{
        display: 'flex',
        alignItems: matches ? '' : 'center',
        justifyContent: 'center',
      }}
    >
      <Grid
        container
        item
        style={{
          backgroundColor: 'white',
          outline: 'none',
          marginTop: matches ? '20%' : '0px',
          maxHeight: matches ? '500px' : '700px',
          position: 'relative',
          width: '40%',
          minWidth: '300px',
        }}
      >
        <Box sx={{ position: 'absolute', top: '10px', right: '10px' }}>
          <CloseIcon
            style={{ cursor: 'pointer', color: SIDEBAR_COLOR }}
            onClick={closeUserDetailsFormModal}
          />
        </Box>
        <Grid
          item
          xs={12}
          style={{
            // height: '100px',
            maxHeight: '180px',
            padding: matches ? '10px' : '20px',
            backgroundColor: COLOR_PRIMARY_1,
            border: 'none',
            borderBottomLeftRadius: '12px',
            borderBottomRightRadius: '12px',
            boxShadow: '0 4px 12px #0002',
          }}
        >
          <Typography
            variant={matches ? 'h6' : 'h5'}
            style={{ textAlign: 'center', fontWeight: 500, color: SIDEBAR_COLOR }}
          >
            Match with one of Airbtics' trusted partners
          </Typography>
          <Typography variant="body2" style={{ textAlign: 'center', color: '#eee' }}>
            Share your details below, and we’ll introduce to a short-term rental specialized realtor
            in your market.
          </Typography>
        </Grid>
        <Grid
          container
          item
          xs={12}
          style={{
            maxHeight: matches
              ? '330px'
              : showEmailNotEnteredWarning || showEnterValidEmailWarning
              ? '460px'
              : '530px',
            overflow: 'auto',
          }}
        >
          <Grid
            container
            item
            xs={12}
            style={{
              padding: '20px 40px',
            }}
          >
            <Grid item xs={12} style={{ marginTop: '15px' }}>
              <Typography variant="body1" style={{ fontWeight: 500 }}>
                Name:
              </Typography>
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                fullWidth
                value={name}
                onChange={e => {
                  setName(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-input': {
                    padding: '10px',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: '15px' }}>
              <Typography variant="body1" style={{ fontWeight: 500 }}>
                Email:
              </Typography>
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                fullWidth
                value={email}
                onChange={e => {
                  setEmail(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-input': {
                    padding: '10px',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: '15px' }}>
              <Typography variant="body1" style={{ fontWeight: 500 }}>
                Phone:
              </Typography>
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                fullWidth
                value={phoneNumber}
                onChange={e => {
                  setPhoneNumber(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-input': {
                    padding: '10px',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: '15px' }}>
              <Typography variant="body1" style={{ fontWeight: 500 }}>
                Your total budget:
              </Typography>
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                fullWidth
                value={budget}
                onChange={e => {
                  setBudget(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-input': {
                    padding: '10px',
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: '15px' }}>
              <Typography variant="body1" style={{ fontWeight: 500 }}>
                Any Other Notes?
              </Typography>
              <TextField
                id="outlined-multiline-static"
                label=""
                variant="outlined"
                fullWidth
                multiline
                value={additionNote}
                onChange={e => {
                  setAdditionalNote(e.target.value);
                }}
                rows={2}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            height: showEmailNotEnteredWarning || showEnterValidEmailWarning ? '110px' : '60px',
            padding: '10px',
          }}
        >
          <Button
            className="classes.button"
            style={{
              width: '100%',
              backgroundColor: COLOR_PRIMARY_1,
              color: SIDEBAR_COLOR,
              borderRadius: '10px',
              // '&:hover': { backgroundColor: COLOR_PRIMARY_1, color: SIDEBAR_COLOR },
            }}
            onClick={() => {
              sendMailAfterFormSubmission();
              setIsFormSubmitted(true);
              handleOnSubmitBtn();
            }}
          >
            Submit
          </Button>
          {showEmailNotEnteredWarning && (
            <Box sx={{ margin: '10px 0px' }}>
              <Alert severity="warning" sx={{ padding: '0px 5px' }}>
                Please enter your email ID.
              </Alert>
            </Box>
          )}
          {showEnterValidEmailWarning && (
            <Box sx={{ margin: '10px 0px' }}>
              <Alert severity="error" sx={{ padding: '0px 5px' }}>
                Please enter a valid email ID.
              </Alert>
            </Box>
          )}
        </Grid>
      </Grid>
    </Modal>
  );
};

export default RealtorForm;
